import List from './List'
import ActionBar from './ActionBar'
import RoleDetail from './RoleDetail'
import {connect} from 'react-redux'
import NoDataAndLoading from 'components/NoDataAndLoading'
import styles from './Role.css'
import {
  onClickRow,
  closeRightColumn,
  onClickNewRole,
  rolesRequest,
  pageRequest,
  setRoles
} from 'actions/employees/role'
import _groupBy from 'lodash/groupBy'
import {askConfirmAction} from 'actions/confirm-action'
import {isDirty} from 'redux-form'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import {browserHistory} from 'react-router'

class Role extends React.Component {

  componentWillMount () {
    this.props.pageRequest(this.props.user.id)
  }

  componentWillUnmount () {
    this.props.setRoles([])
  }

  componentDidMount () {
    if (this.props.expired) {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let {role, closeRightColumn, loadingSpinner: {showLoadingSpinnerPage}} = this.props
    return (
      <PageWrapper>
        <ContentWrapper>
          <ActionBar onClickNewRole={this._onClickNewRole} />
          <div className={styles.container}>
            <LeftColumnWrapper openRightColumn={role.openRightColumn} isWiderLeft>
              <NoDataAndLoading
                showLoadingSpinner={showLoadingSpinnerPage}
                noDataToDisplay={role.roles.length === 0}
                title='No role information'
                description={'you can create a role and setup employee privileges by clicking "New Role" button on the top right corner'} />
              {!showLoadingSpinnerPage && role.roles.length !== 0 && <List
                role={role}
                onClickRow={this._onClickRow}
                onReachBottom={this._onReachBottom}
                hasMore={this._hasMore()}
                userPermissions={this.props.permissions}
                openRightColumn={role.openRightColumn}
                />}
            </LeftColumnWrapper>
            <RightColumnWrapper openRightColumn={role.openRightColumn} isWiderLeft menuName='role'>
              <RoleDetail closeRightColumn={closeRightColumn} />
            </RightColumnWrapper>
          </div>
        </ContentWrapper>
      </PageWrapper>
    )
  }

  _onClickNewRole = () => {
    let {askConfirmAction, isDirtyRole} = this.props
    let data = {activePermissionApp: _groupBy(this.props.permissions, 'access')['App']}

    if (isDirtyRole) {
      askConfirmAction(onClickNewRole(data))
    } else {
      this.props.onClickNewRole(data)
    }
  }

  _onClickRow = (role) => {
    let {askConfirmAction, isDirtyRole} = this.props
    if (isDirtyRole) {
      askConfirmAction(onClickRow(role))
    } else {
      this.props.onClickRow(role)
    }
  }

  _onReachBottom = () => {
    let {currentPage, role, rolesRequest} = this.props
    rolesRequest({page: currentPage + 1}, role.roles)
  }

  _hasMore = () => {
    let {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }
}

function mapStateToProps (state) {
  let {loadingSpinner, moka: {permissions, user}, employee: {role}, subscriptionExpired: {expired}} = state
  return {
    role,
    loadingSpinner,
    user,
    permissions,
    isDirtyRole: isDirty('role')(state),
    expired
  }
}

export default connect(mapStateToProps, {
  onClickRow,
  onClickNewRole,
  closeRightColumn,
  rolesRequest,
  pageRequest,
  setRoles,
  askConfirmAction
})(Role)



// WEBPACK FOOTER //
// ./app/pages/Employees/Role/Role.js